import React from 'react';
export function CrescentMoon({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`animate-float ${className}`} data-id="element-16">
      <svg width="80" height="80" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="drop-shadow-[0_0_15px_rgba(201,168,76,0.6)]" data-id="element-17">
        <path d="M50 5C60.5 5 70.5 8.5 78.5 14.5C65 16.5 54 27.5 54 41.5C54 57.5 67 70.5 83 70.5C84.5 70.5 86 70.5 87.5 70C80 82 66 90 50 90C26.5 90 7.5 71 7.5 47.5C7.5 24 26.5 5 50 5Z" fill="#C9A84C" fillOpacity="0.9" data-id="element-18" />
        <path d="M50 5C60.5 5 70.5 8.5 78.5 14.5C65 16.5 54 27.5 54 41.5C54 57.5 67 70.5 83 70.5C84.5 70.5 86 70.5 87.5 70C80 82 66 90 50 90C26.5 90 7.5 71 7.5 47.5C7.5 24 26.5 5 50 5Z" stroke="#F5F0FF" strokeWidth="1" strokeOpacity="0.5" data-id="element-19" />
      </svg>
    </div>;
}